<template>    
    <button v-if="displayButton" :aria-disabled="String(disabled)" :class="getClasses" :id="id" :type="type" :action="action" @click="emitAction">
        <fa-icon v-if="icon && icon.position == 'left'" :icon="icon.name" class="icon mr-2" />
        <span v-html="label"></span>
        <fa-icon v-if="icon && icon.position == 'right'" :icon="icon.name" class="icon ml-2" />
    </button>
    <div v-else-if="displayLoader" :class="spinnerMarkers"></div>
</template>

<script>
import addVModelWatchers from "../mixins/addVModelWatchers.js";

    export default {
        name: "Action",

        mixins: [
            addVModelWatchers({
                modelProp: "hidden",
                modelDataName: "dataHidden"
            })
        ],

        emits: ['emit-action'],

        props: {
            label: String,
            action: String,
            classMarkers: String,
            icon: Object,
            type: {
                type: String,
                default: "button",
            },
            id: {
                type: String,
                default: null
            },
            spinnerMarkers: {
                type: String,
                default: "spinner-border theme-primary mt-3"
            },
            hidden: {
                type: Boolean,
                default: false
            }
        },

        data: function() {
            return {
                showLoading: false,
                disabled: false
            }
        },

        methods: {
            emitAction: function(e) {
                if(this.type == 'submit' && this.$el.tagName.toLowerCase() == 'button' && this.$el.closest('form'))
                    e.preventDefault();

                if (!this.disabled)
                    this.$emit('emit-action', this.action, e);
            },

            startLoading: function(e) {                
                if (this.action === e) {
                    this.showLoading = true;
                }
            },

            stopLoading: function(e) {
                if (this.action === e) {
                    this.showLoading = false;
                }
            },

            disable: function(e) {
                if (this.action === e) {
                    this.disabled = true;
                }
            },

            enable: function(e) {
                if (this.action === e) {
                    this.disabled = false;
                }
            },

            hide: function(e) {
                if (this.action === e) {
                    this.dataHidden = true;
                }
            },

            show: function(e) {
                if (this.action === e) {
                    this.dataHidden = false;
                }
            }
        },

        computed: {
            getClasses: function() {
                var classes = this.classMarkers;

                if (this.disabled) {
                    classes += " disabled";
                }

                return classes;
            },
            
            displayButton: function() {
                return !this.dataHidden && !this.showLoading;
            },

            displayLoader: function() {
                return !this.dataHidden && this.showLoading;
            }
        },

        mounted: function() {
            this.$emitter.on('start-loading', this.startLoading);
            this.$emitter.on('stop-loading', this.stopLoading);
            this.$emitter.on('disable', this.disable);
            this.$emitter.on('enable', this.enable);
            this.$emitter.on('hide', this.hide);
            this.$emitter.on('show', this.show);
        },

        beforeUnmount: function() {
            this.$emitter.off('start-loading', this.startLoading);
            this.$emitter.off('stop-loading', this.stopLoading);
            this.$emitter.off('disable', this.disable);
            this.$emitter.off('enable', this.enable);
            this.$emitter.off('hide', this.hide);
            this.$emitter.off('show', this.show);
        }
    }
</script>

<style scoped>
    .btn:focus{
        box-shadow: 0 0 0 0.2rem rgba(0, 10, 210, 1)
    }
    
    .full-width {
        width: 100%;
    }

    .initial-width {
        width: initial;
    }

    @media(min-width: 1200px) {
        .full-xl-width {
            width: 100%;
        }

        .initial-xl-width {
            width: initial;
        }
    }

    @media(min-width: 992px) {
        .full-lg-width {
            width: 100%;
        }

        .initial-lg-width {
            width: initial;
        }
    }

    @media(min-width: 768px) {
        .full-md-width {
            width: 100%;
        }

        .initial-md-width {
            width: initial;
        }
    }
</style>
